<template>
  <div>
    <b-btn
      variant="none"
      class="btn-outline-primary btn-sm"
      style="padding:0.5rem;"
      @click="abrirModalCadastroFunil"
    >
      <font-awesome-icon
        :icon="faPlus"
      />
      <span style="color: #6e6b7b;">&nbsp;Novo Funil</span>
    </b-btn>

    <b-modal
      ref="modalCadastroFunil"
      title="Cadastre um novo funil"
      size="sm"
      no-close-on-background
      :footer-class="'custom-footer-class'"
      :dialog-class="'alteracao-tamanho'"
      :modal-class="'center-modal'"
    >
      <div>
        <b-input
          v-model="novoFunil.name"
          name="inputNovoFunil"
          placeholder="Nome do funil..."
          autofocus
        />

        <!-- <b-input
          v-model="novoFunil.description"
          name="inputDescricaoFunil"
          placeholder="Descrição do funil"
          style="margin-top: 12px;"
        />
        -->
      </div>

      <template #modal-footer>
        <b-button
          block
          size="md"
          class="btn-criar"
          variant="primary"
          @click="criarFunil"
        >
          Criar
        </b-button>
      </template>
    </b-modal>
  </div>

</template>

<style>

</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/oportunidades/shared/services/api'

export default {
  name: 'CadastroFunil',
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      faPlus,
      novoFunil: this.novoFunilBase(),
    }
  },
  computed: {
    podeSalvar() {
      return (
        this.novoFunil.name
      )
    },
  },
  methods: {
    abrirModalCadastroFunil() {
      this.$refs.modalCadastroFunil.show()
    },
    async criarFunil() {
      if (!this.podeSalvar) {
        this.$erro('Preencha os campos para poder prosseguir.')
        return false
      }
      try {
        const response = await api.createPipeline({
          ...this.novoFunil,
        })
        const novoFunilCriado = response && response.data ? response.data : null
        this.$refs.modalCadastroFunil.hide()
        this.$sucesso('Funil criado com sucesso.')
        this.$emit('funil-criado', novoFunilCriado)
        this.novoFunil = this.novoFunilBase()
      } catch {
        this.$erro('Erro ao criar funil. Tente novamente mais tarde.')
      }
      return null
    },
    novoFunilBase() {
      return {
        name: '',
        description: '',
      }
    },
  },
}
</script>
